
export default function Footer() {
  const quickLinks = ['기업소개', '컨설팅 분야', '수행실적', '자료실'];

  /** Scroll smoothly to the element with the given id.
   *  If the id is falsy or the element does not exist, the function
   *  exits silently – this prevents runtime errors when the target
   *  section is missing. */
  const scrollToSection = (id: string) => {
    if (!id) return;
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#0f1a2e] text-white">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-12 sm:py-20">
        {/* Top Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-8 sm:mb-12">
          {/* Company Info */}
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/610af156-a17e-4843-b51d-56e6ec41338a.png"
              alt="더불어안전 로고"
              className="h-10 sm:h-12 w-auto mb-3 sm:mb-4 brightness-0 invert"
            />
            <div className="text-sm sm:text-base font-semibold mb-2 sm:mb-3">
              (주)더불어안전 / 한창안전기술사사무소
            </div>
            <p className="text-xs sm:text-sm text-gray-400 leading-relaxed mb-3 sm:mb-4">
              고용노동부 지정 재해예방전문지도기관<br />
              국내 최고 수준의 건설안전 컨설팅 전문기관
            </p>
            <div className="text-xs text-gray-500">지정번호: 제2025-050632호</div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs sm:text-sm font-semibold text-[#ff6b35] tracking-wider mb-4 sm:mb-5">
              QUICK LINKS
            </h4>
            <ul className="space-y-3 sm:space-y-4">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() =>
                      scrollToSection(
                        link === '기업소개'
                          ? 'about'
                          : link === '컨설팅 분야'
                          ? 'consulting'
                          : link === '수행실적'
                          ? 'performance'
                          : 'resources'
                      )
                    }
                    className="text-sm sm:text-base text-white hover:text-[#ff6b35] transition-colors whitespace-nowrap"
                  >
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs sm:text-sm font-semibold text-[#ff6b35] tracking-wider mb-4 sm:mb-5">
              CONTACT
            </h4>
            <ul className="space-y-3 sm:space-y-4">
              <li className="flex items-start gap-2.5 sm:gap-3">
                <i className="ri-phone-line text-[#ff6b35] mt-0.5 sm:mt-1"></i>
                <div>
                  <div className="text-xs sm:text-sm text-gray-400 mb-0.5 sm:mb-1">
                    전화번호
                  </div>
                  <div className="text-sm sm:text-base">041-353-7253</div>
                </div>
              </li>
              <li className="flex items-start gap-2.5 sm:gap-3">
                <i className="ri-mail-line text-[#ff6b35] mt-0.5 sm:mt-1"></i>
                <div>
                  <div className="text-xs sm:text-sm text-gray-400 mb-0.5 sm:mb-1">
                    이메일
                  </div>
                  <div className="text-sm sm:text-base break-all">
                    safetygo@kakao.com
                  </div>
                  <div className="text-sm sm:text-base break-all">
                    kohyoungju@naver.com
                  </div>
                </div>
              </li>
              <li className="flex items-start gap-2.5 sm:gap-3">
                <i className="ri-map-pin-line text-[#ff6b35] mt-0.5 sm:mt-1"></i>
                <div>
                  <div className="text-xs sm:text-sm text-gray-400 mb-0.5 sm:mb-1">
                    주소
                  </div>
                  <div className="text-sm sm:text-base">
                    (31771) 충남 당진시 밤절로 136 씨티타워 7층 704호
                  </div>
                </div>
              </li>
            </ul>
          </div>

          {/* Inquiry */}
          <div>
            <h4 className="text-xs sm:text-sm font-semibold text-[#ff6b35] tracking-wider mb-4 sm:mb-5">
              INQUIRY
            </h4>
            <p className="text-xs sm:text-sm text-gray-400 mb-3 sm:mb-4">
              상담 문의를 남겨주시면<br />
              빠르게 연락드리겠습니다.
            </p>
            <div className="flex gap-2">
              <input
                type="email"
                placeholder="이메일 주소 입력"
                className="flex-1 min-w-0 bg-transparent border-b border-white/30 py-2 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-[#ff6b35] transition-colors"
              />
              <button className="w-9 h-9 sm:w-10 sm:h-10 bg-[#ff6b35] rounded-lg flex items-center justify-center hover:bg-[#ff5722] transition-colors flex-shrink-0">
                <i className="ri-arrow-right-line text-white"></i>
              </button>
            </div>
            <p className="text-xs text-gray-500 mt-2 sm:mt-3">
              <a href="#" className="hover:text-[#ff6b35] transition-colors">
                개인정보처리방침
              </a>{' '}
              동의
            </p>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-white/10 pt-6 sm:pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <div className="text-xs sm:text-sm text-gray-500 text-center sm:text-left">
            © 2025 더불어안전. All rights reserved. |{' '}
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#ff6b35] transition-colors"
            >
              Website Builder
            </a>
          </div>
          <div className="flex gap-3 sm:gap-4">
            <a
              href="#"
              className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#ff6b35] transition-colors"
            >
              <i className="ri-kakao-talk-fill"></i>
            </a>
            <a
              href="#"
              className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#ff6b35] transition-colors"
            >
              <i className="ri-youtube-fill"></i>
            </a>
            <a
              href="#"
              className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#ff6b35] transition-colors"
            >
              <i className="ri-mail-fill"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
